import { useState } from "react";
import { useApiError } from "@infrastructure/api/hooks/useApiError";
import {
    createFinanceCategoryAsync,
    updateFinanceCategoryAsync,
    disableFinanceCategoryAsync,
    enableFinanceCategoryAsync,
} from "@features/admin/finance/category/services/financeCategorySvc";
import {
    CreateFinanceCategoryRequest,
    UpdateFinanceCategoryRequest,
} from "@features/admin/finance/category/types/financeCategoryRequests";

export function useFinanceCategoryAction() {
    const [busy, setBusy] = useState(false);
    const _showError = useApiError();

    const doCreate = async (nationId: number, data: CreateFinanceCategoryRequest) => {
        setBusy(true);
        const response = await createFinanceCategoryAsync(nationId, data);
        setBusy(false);
        return response;
    };

    const doUpdate = async (
        nationId: number,
        categoryGroupId: number,
        data: UpdateFinanceCategoryRequest
    ) => {
        setBusy(true);
        const response = await updateFinanceCategoryAsync(nationId, categoryGroupId, data);
        setBusy(false);
        return response;
    };

    const doDisable = async (nationId: number, categoryGroupId: number) => {
        setBusy(true);
        const response = await disableFinanceCategoryAsync(nationId, categoryGroupId);
        setBusy(false);
        return response;
    };

    const doEnable = async (nationId: number, categoryGroupId: number) => {
        setBusy(true);
        const response = await enableFinanceCategoryAsync(nationId, categoryGroupId);
        setBusy(false);
        return response;
    };

    return { busy, doCreate, doUpdate, doDisable, doEnable };
}
